module.exports = __webpack_public_path__ + "img/yellow-square-table-1.3ebf9243.png";